<div class="sidebar-wrapper">
  <div class="sidebar">
    <div class="d-flex justify-content-between align-items-center">
      <h1 class="sidebar__title m-0">Books Review</h1>
      <!-- <i class="tio-settings opacity-50 fs-5" style="cursor: pointer"></i> -->
    </div>
    <div class="navigation">
      <div class="filter-card">
        <div class="small-label">Date Range</div>
        <div class="dropdown-timetracking">
          <span
            dropdown
            #dropdown="bs-dropdown"
            class="btn-group d-inline-block"
            container="body"
            insideClick="true"
            autoClose="outside"
          >
            <button dropdownToggle class="btn btn-icon rounded px-0">
              <i class="tio-calendar_note"></i> {{ displayTimeFrameFilter }}
              <i class="tio-chevron_down"></i>
            </button>

            <ul
              style="
                min-width: 280px;
                overflow: visible;
                max-height: fit-content;
              "
              *dropdownMenu
              class="dropdown-menu dropdown-menu-right dropdown-books-review"
              aria-labelledby="dLabel"
              role="menu"
            >
              <ng-container *ngFor="let option of timeFrames">
                @if (shouldDisplayTimeFrame(option.value)) {
                  <li
                    *ngIf="option.separator"
                    class="separator-container"
                    role="separator"
                  >
                    <hr class="my-2 separator" />
                  </li>
                  <li *ngIf="!option.separator" role="menuitem">
                    <a
                      class="dropdown-item"
                      (click)="
                        changeTimeFrameFilter(option.value);
                        onDateChange();
                        dropdown.hide()
                      "
                    >
                      {{ option.label }}
                    </a>
                  </li>
                }
              </ng-container>
            </ul>
          </span>
        </div>
        <div class="formated-time-frame mb-3">
          {{ formatedTimeFrame }}
        </div>
      </div>

      <hr class="separator" />
      <a
        routerLink="inconsistencies"
        [routerLinkActive]="['active']"
        class="d-flex justify-content-between align-items-center"
      >
        <span>Expense Inconsistencies</span>
        <!-- <ds-badge [number]="7" /> -->
      </a>
      <a
        routerLink="transactions-without-payee"
        [routerLinkActive]="['active']"
        class="d-flex justify-content-between align-items-center"
      >
        <span>Purchases without payee</span>
        <!-- <ds-badge [number]="3" /> -->
      </a>
      <a
        routerLink="purchases-coded-to-parent-accounts"
        class="d-flex justify-content-between align-items-center"
        [routerLinkActive]="['active']"
      >
        <span>Purchases in parent accounts</span>
      </a>
      <a
        routerLink="large-transactions"
        class="d-flex justify-content-between align-items-center"
        [routerLinkActive]="['active']"
      >
        <span>Large transactions</span>
        <!-- <ds-badge [number]="1" /> -->
      </a>
      <a
        routerLink="transactions-without-attachments"
        class="d-flex justify-content-between align-items-center"
        [routerLinkActive]="['active']"
      >
        <span>Transactions Without Attachments</span>
      </a>
      <hr class="separator" />
      <a
        routerLink="new-accounts"
        [routerLinkActive]="['active']"
        class="d-flex justify-content-between align-items-center"
      >
        <span>New Accounts</span>
        <!-- <ds-badge [number]="10" /> -->
      </a>
      <a
        routerLink="new-vendors"
        [routerLinkActive]="['active']"
        class="d-flex justify-content-between align-items-center"
      >
        <span>New Vendors</span>
      </a>
      <a
        routerLink="new-customers"
        [routerLinkActive]="['active']"
        class="d-flex justify-content-between align-items-center"
      >
        <span>New Customers</span>
      </a>
      <hr class="separator" />
      <a
        routerLink="balance-sheet-review"
        class="d-flex justify-content-between align-items-center"
        [routerLinkActive]="['active']"
      >
        <span>Balance Sheet Review</span>
      </a>
      <a
        routerLink="profit-and-loss-review"
        class="d-flex justify-content-between align-items-center"
        [routerLinkActive]="['active']"
      >
        <span>Profit And Loss Review</span>
      </a>
    </div>
  </div>
</div>

<div class="container-fluid">
  <div class="booksreview-scroll">
    @if (isChildRouteActive) {
      <div class="mt-4 mb-4 ms-3">
        <!-- <button class="btn btn-primary">Batch actions</button> -->

        <div class="d-flex gap-2 align-items-center">
          <!-- <p-dropdown
              [options]="reviewOptions"
              [(ngModel)]="reviewedFilter"
              optionLabel="name"
              placeholder="Status"
              (onChange)="onReviewedFilterChange()"
            /> -->
          <!-- View: -->
          @if (showReviewedHeader()) {
            <div class="default-toggle">
              <div
                (click)="onReviewedFilterChange('notReviewed')"
                [ngClass]="{
                  'filter-active': reviewedFilter.name != 'Reviewed',
                }"
              >
                Not Reviewed
              </div>
              <div
                (click)="onReviewedFilterChange('reviewed')"
                [ngClass]="{
                  'filter-active': reviewedFilter.name == 'Reviewed',
                }"
              >
                Reviewed
              </div>
            </div>
            <button
              (click)="refreshLists()"
              class="btn btn-default ms-2"
              container="body"
              tooltip="Refresh accounts, classes and payees."
            >
              <i class="tio-refresh"></i> Refresh lists
            </button>
          }
        </div>
      </div>
    }
    @if (showEmptyState()) {
      <div class="empty-state">
        <div class="text-center">
          <svg
            width="66"
            height="58"
            viewBox="0 0 66 58"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M44.3412 40.9371L28.3902 26.0269C28.0753 25.7336 27.6161 25.6543 27.2211 25.8251C26.8261 25.9967 26.571 26.3859 26.571 26.8169V48.4404C26.571 48.8563 26.8096 49.2354 27.1844 49.4149C27.5585 49.5958 28.0039 49.5447 28.3283 49.2845L32.7337 45.7584L36.8976 55.3491C37.1355 55.8969 37.7727 56.1485 38.3198 55.9099L41.6253 54.4741C42.1731 54.2362 42.4239 53.5998 42.186 53.052L39.992 47.9986L38.0221 43.462L43.7264 42.8024C44.1451 42.7542 44.4976 42.4666 44.6295 42.0665C44.7614 41.665 44.649 41.2254 44.3412 40.9371Z"
              fill="#151C29"
            />
            <path
              d="M19.1109 30.6468L8.94971 34.6233"
              stroke="#959DAB"
              stroke-width="2"
              stroke-linecap="round"
            />
            <path
              d="M47.6245 19.4881L37.4633 23.4647"
              stroke="#959DAB"
              stroke-width="2"
              stroke-linecap="round"
            />
            <path
              d="M21.4349 9.56509L25.4114 19.7263"
              stroke="#959DAB"
              stroke-width="2"
              stroke-linecap="round"
            />
            <path
              d="M10.8109 18.8923L20.3718 24.1507"
              stroke="#959DAB"
              stroke-width="2"
              stroke-linecap="round"
            />
            <path
              d="M35.2312 9.09481L31.9558 19.5032"
              stroke="#959DAB"
              stroke-width="2"
              stroke-linecap="round"
            />
          </svg>
          <h4 class="mt-3">Select a report</h4>
        </div>
      </div>
    }

    <router-outlet />
  </div>
</div>
